if (!customElements.get('bundle-product')) {
	customElements.define(
		'bundle-product',
		class BundleProduct extends HTMLElement {
			constructor() {
				super();
				this.variantSelects = this.querySelectorAll('.variant-select select');
			}

			connectedCallback(){
    			this.optionData = JSON.parse(document.querySelector('.product #product-data').textContent);

	        this.variantSelects.forEach((selected, index) => {
					  selected.addEventListener("change", (e) => {
					  	var parent = e.target.closest('.variants-wrapper');
					  	var selected_product = parent.querySelector('select[name="options[type]"]').value
					  	if(e.target.name == 'options[type]'){
					  		this.updateOptions(e, index)
					  		this.updateVariantID(e, e.target.value)	
					  	} else {
					  		this.getSelectedOptions(e)
					  		this.updateVariantID(e, selected_product)
					  	}
					  });
					});
			}

			getSelectedOptions(event){
				var wrapper = event.target.closest('.variants-wrapper')

		    this.options = Array.from(
		      wrapper.querySelectorAll(".variant-select:not(.product) select"),
		      (element) => {
		        if (element.tagName === "SELECT") {
		          return element.value;
		        }
		      }
		    );
			}

			updateOptions(event, index){
				var selected_product = event.target.value;
				var event_wrapper = event.target.closest('.variants-wrapper')
				var options = this.optionData[selected_product] || [];
				var sizeSelect = event_wrapper.querySelector('select[name="options[Shoe size]"]');
				var colorSelect = event_wrapper.querySelector('select[name="options[Color]"]');

				// update sizes
		    var sizeOption = options.find(opt => opt.name === "Shoe size");
		    if (sizeOption) {
			    sizeSelect.innerHTML = "";
		      sizeOption.values.forEach(val => {
		        let o = document.createElement("option");
		        o.value = val;
		        o.textContent = 'US ' + val;
		        sizeSelect.appendChild(o);
		      });
		    }

		    // update colors
		    var colorOption = options.find(opt => opt.name === "Color");
		    if (colorOption) {
			    colorSelect.innerHTML = "";
		      colorOption.values.forEach(val => {
		        let o = document.createElement("option");
		        o.value = val;
		        o.textContent = val;
		        colorSelect.appendChild(o);
		      });
		    }

		    this.getSelectedOptions(event)
			}

			updateVariantID(selector, selected_product){
				var jsonData = document.querySelector(`product-info[data-product="${selected_product}"] [type="application/json"]`)
				if(jsonData){
					this.variantData = JSON.parse(jsonData.textContent);
				
					this.currentVariant = this.variantData.find((variant) => {
			      return !variant.options
			        .map((option, index) => {
			          return this.options[index] === option;
			        })
			        .includes(false);
			    });

			    if(this.currentVariant){
			    	var variant_id = selector.target.closest('.variants-wrapper')
			    	variant_id.setAttribute("data-variant-id", this.currentVariant.id);
			    }
				}
			}
		}
	)
}